// removed by extract-text-webpack-plugin
module.exports = {"root":"_2kcxp_2k","top":"_3ENlp_3E","active":"_3Go3Y_3G","right":"_2HQbV_2H"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Dropdown/DropdownContent.css
// module id = 745
// module chunks = 0